export const NAME = 'modal';
